// Feature flags stored in the backend `settings` table and toggled via the DB.
// Side-effect-free (no config/apollo imports) so the feature-flag loader,
// context and the useFeatureFlag hook can all import it freely.
export const DB_GUARANTEES_V2 = 'guarantees_v2';
export const DB_GUARANTEES_API_V2 = 'guarantees_api_v2';
export const DB_ELIGIBILITY_ENGINE = 'eligibility_engine';
export const DB_MULTI_SUBSCRIPTION = 'multi_subscription';
export const DB_DEALER_SEARCH_VALIDATION_OFF = 'dealer_search_validation_off';
// E58344 / F313311: one flag for the whole feature - the Masters screen, the dealer Opt-Outs
// screen, and per-auction-location enablement. It gates visibility only; the behavioural switch
// is APMS's dynamic_properties.currentVersion (off / OBSERVE / WRITE). Per-screen permissions
// stay in the role gates (ACCESS.*), not here.
export const DB_DEFAULT_COVERAGE = 'default_coverage';